import React from 'react';
import type { MessageDescriptor } from 'react-intl';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { MarketType } from '@swf/generated/types/api/sports';
import type { IconName } from '@swf/sports/types/icon';
import type { OddsBoostMarket } from '@swf/sports/utils/isOddsBoostMarket';
import isOddsBoostMarket from '@swf/sports/utils/isOddsBoostMarket';

import { Icon } from '../Icon/Icon';

import { TXTWCL_odds_boost } from './MarketTypeIcon.messages.json';
import styles from './MarketTypeIcon.scss';

// TODO: GSFE-1417: remove POWER_PRICES
const iconMap: Record<
  OddsBoostMarket,
  { name: IconName; className: string; title: MessageDescriptor }
> = {
  POWER_PRICES: {
    name: 'price-boost',
    className: 'oddsBoost',
    title: TXTWCL_odds_boost
  },
  ODDS_BOOST: {
    name: 'price-boost',
    className: 'oddsBoost',
    title: TXTWCL_odds_boost
  },
  DAILY_POWER_PRICES: {
    name: 'price-boost',
    className: 'oddsBoost',
    title: TXTWCL_odds_boost
  },
  POWER_PRICE: {
    name: 'price-boost',
    className: 'oddsBoost',
    title: TXTWCL_odds_boost
  }
};

interface Props {
  marketType?: MarketType;
}

export const MarketTypeIcon: React.FC<Props> = ({ marketType }) => {
  const { formatMessage } = useRegulatoryIntl();
  if (!marketType || !isOddsBoostMarket(marketType)) return null;

  const icon = iconMap[marketType];

  return (
    <div className={styles[icon.className]}>
      <Icon name={icon.name} label={formatMessage(icon.title)} size="xl" />
    </div>
  );
};
